import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "selectExternalJobButton",
    "clearExternalJobButton",
    "changeProfileInputTypeButton",
    "externalJobItem",
    "selectJobTitleButton",
    "generateProfileDialog",
  ];

  static classes = ["hidden"];

  static values = {
    formPrefix: String,
  };

  externalJobFieldMap = {
    "lever.leverposting": "lever_posting",
    "successfactors.successfactorsjob": "successfactors_job",
    "zoho.zohojob": "zoho_job",
  };

  addPrefix(fieldName) {
    return `${this.formPrefixValue}-${fieldName}`;
  }

  changeProfileInputType() {
    if (this.hasChangeProfileInputTypeButtonTarget) {
      this.changeProfileInputTypeButtonTarget.click();
    }
  }

  selectJobTitle() {
    if (this.hasSelectJobTitleButtonTarget) {
      this.selectJobTitleButtonTarget.click();
    }
  }

  /**
   * Replaces the external job input fields for the ATS with the new external
   * job.
   * Also updates the form's `name`, `department` and `description` fields.
   */
  addExternalJob(e) {
    if (!this.hasFormTarget) {
      return;
    }

    const {
      detail: { externalJob },
    } = e;

    const name = [externalJob.fields.name, externalJob.fields.location]
      .filter(Boolean)
      .join(", ");
    this.formTarget.elements[this.addPrefix("name")].value = name;

    ["department", "description"].forEach((fieldName) => {
      const input = this.formTarget.elements[this.addPrefix(fieldName)];
      input.value = externalJob.fields[fieldName] || "";
    });

    const fullName = [
      externalJob.fields.name,
      externalJob.fields.department,
      externalJob.fields.location,
    ]
      .filter(Boolean)
      .join(", ");
    const field = this.addPrefix(this.externalJobFieldMap[externalJob.model]);
    this.formTarget.elements[field].value = externalJob.fields.id;
    this.formTarget.elements[`${field}_full_name`].value = fullName;

    if (this.hasSelectExternalJobButtonTarget) {
      this.selectExternalJobButtonTarget.click();
    }
  }

  /**
   * Shows the `clearExternalJobButtonTarget` targets.
   */
  clearExternalJobButtonTargetConnected(target) {
    target.classList.remove(this.hiddenClass);
  }

  /**
   * Clears the external job input fields for the ATS given by the button's
   * integration param.
   * Removes the `li` of that ATS.
   */
  clearExternalJob(e) {
    const {
      params: { field },
    } = e;

    const formField = this.addPrefix(field);

    if (this.hasFormTarget) {
      this.formTarget.elements[formField].value = "";
      this.formTarget.elements[`${formField}_full_name`].value = "";
    }

    this.externalJobItemTargets.forEach((item) => {
      if (item.dataset.field === field) {
        item.remove();
      }
    });
  }

  showGenerateProfileDialog(event) {
    event.preventDefault();
    this.generateProfileDialogTarget.showModal();
  }

  discardGenerateProfileDialog() {
    this.generateProfileDialogTarget.close();
  }
}
